import { render, staticRenderFns } from "./ProjectPropertyList.vue?vue&type=template&id=5a3dfa1f&"
import script from "./ProjectPropertyList.vue?vue&type=script&lang=ts&"
export * from "./ProjectPropertyList.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectPropertyList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports